import { getEl, hasAttr } from '../helpers/helpers.js'
import { getTheme, initTheme, setTheme } from '../helpers/preferences.js'

const isFrontPage = hasAttr(document.body, 'data-front-page')

export default function setFrontPage() {
	initTheme()
	if (!isFrontPage) return

	const themeSelect = getEl('[data-theme-select]')
	const themeControl = getEl('[data-theme-control]')
	if (themeSelect) {
		const storedTheme = getTheme('system')
		themeSelect.value = storedTheme
		updateThemeControl(themeControl, storedTheme)
		themeSelect.addEventListener('change', (event) => {
			const value = event.target.value
			setTheme(value)
			updateThemeControl(themeControl, value)
		})
	}

	const themeButton = getEl('[data-theme-button]')
	const themeList = getEl('[data-theme-list]')
	if (themeButton && themeList) {
		const storedTheme = getTheme('system')
		updateThemeControl(themeControl, storedTheme)
		updateThemeButton(themeButton, storedTheme)
		themeList.querySelectorAll('[data-theme-value]').forEach((button) => {
			button.addEventListener('click', () => {
				const value = button.getAttribute('data-theme-value')
				if (!value) return
				setTheme(value)
				updateThemeControl(themeControl, value)
				updateThemeButton(themeButton, value)
				closeDropdowns()
			})
		})
	}

	const header = getEl('.site-header')
	const toggle = getEl('[data-header-toggle]')
	const panel = getEl('[data-header-panel]')
	if (header && toggle && panel) {
		toggle.addEventListener('click', () => {
			const isOpen = header.classList.toggle('site-header--open')
			toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false')
		})
	}

	initDropdowns()
}

function updateThemeControl(element, theme) {
	if (!element) return
	element.setAttribute('data-theme', theme)
}

function updateThemeButton(button, theme) {
	if (!button) return
	const labels = {
		system: 'System',
		light: 'Light',
		dark: 'Dark',
	}
	button.textContent = labels[theme] || labels.system
}

function initDropdowns() {
	const dropdowns = document.querySelectorAll('[data-dropdown]')
	if (!dropdowns.length) return
	let dropdownIndex = 0

	dropdowns.forEach((dropdown) => {
		if (!dropdown.dataset.dropdownId) {
			dropdown.dataset.dropdownId = `dropdown-${dropdownIndex}`
			dropdownIndex += 1
		}
		const button = dropdown.querySelector('[data-dropdown-button]')
		const list = dropdown.querySelector('[data-dropdown-list]')
		if (!button || !list) return

		button.addEventListener('click', (event) => {
			event.stopPropagation()
			const isOpen = dropdown.classList.contains('is-open')
			if (isOpen) {
				closeDropdowns()
				return
			}
			closeDropdowns()
			dropdown.classList.add('is-open')
			button.setAttribute('aria-expanded', 'true')
			openFloatingList(dropdown, button, list)
		})

		list.addEventListener('click', (event) => {
			event.stopPropagation()
		})
	})

	document.addEventListener('click', closeDropdowns)
	document.addEventListener('keydown', (event) => {
		if (event.key === 'Escape') closeDropdowns()
	})
	window.addEventListener('scroll', closeDropdowns, true)
	window.addEventListener('resize', closeDropdowns)
}

function closeOtherDropdowns(current) {
	document.querySelectorAll('[data-dropdown].is-open').forEach((dropdown) => {
		if (dropdown !== current) {
			const button = dropdown.querySelector('[data-dropdown-button]')
			const list = dropdown.querySelector('[data-dropdown-list]')
			dropdown.classList.remove('is-open')
			if (button) button.setAttribute('aria-expanded', 'false')
			if (button && list) closeFloatingList(dropdown, button, list)
		}
	})
}

function closeDropdowns() {
	document.querySelectorAll('[data-dropdown].is-open').forEach((dropdown) => {
		const button = dropdown.querySelector('[data-dropdown-button]')
		const list = dropdown.querySelector('[data-dropdown-list]')
		dropdown.classList.remove('is-open')
		if (button) button.setAttribute('aria-expanded', 'false')
		if (button && list) closeFloatingList(dropdown, button, list)
	})

	document.querySelectorAll('[data-dropdown-list].is-floating').forEach((list) => {
		const ownerId = list.dataset.dropdownOwner
		if (!ownerId) return
		const dropdown = document.querySelector(
			`[data-dropdown][data-dropdown-id="${ownerId}"]`
		)
		const button = dropdown?.querySelector('[data-dropdown-button]')
		closeFloatingList(dropdown, button, list)
	})
}

function openFloatingList(dropdown, button, list) {
	const rect = button.getBoundingClientRect()
	const dropdownId = dropdown.dataset.dropdownId || ''
	list.dataset.dropdownOwner = dropdownId
	list.classList.add('is-open', 'is-floating')
	list.style.position = 'fixed'
	list.style.left = `${rect.left}px`
	list.style.top = `${rect.bottom + 6}px`
	list.style.width = `${rect.width}px`
	document.body.appendChild(list)
}

function closeFloatingList(dropdown, button, list) {
	list.classList.remove('is-open', 'is-floating')
	list.style.position = ''
	list.style.left = ''
	list.style.top = ''
	list.style.width = ''
	if (dropdown.contains(list)) return
	dropdown.appendChild(list)
}
